<main-content-holder>
  <h2 class="center-align" i18n="Sign Up Confirm|Sign Up Confirm title@@sign-up-confirm-title">Confirm Your Email Address</h2>

  <div fxLayout="row" fxLayout.lt-md="column" class="full-width">
    <form [formGroup]="signUpConfirmForm" class="center-align">
      <form-input [control]="emailField"
                  label="Email"
                  i18n-label="Sign Up Confirm|Email input label@@sign-up-confirm-email-label"
                  placeholder="Your email..."
                  i18n-placeholder="Sign Up Confirm|Email input placeholder@@sign-up-confirm-email-placeholder"
                  type="email"></form-input>
      <form-input [control]="codeField"
                  label="Confirmation Code"
                  i18n-label="Sign Up Confirm|Confirmation Code input label@@sign-up-confirm-code-label"
                  placeholder="e.g. 000000"
                  i18n-placeholder="Sign Up Confirm|Confirmation Code input placeholder@@sign-up-confirm-code-placeholder"
                  type="number"
                  [minLength]="6" [maxLength]="6"></form-input>

      <app-button *ngIf="!inProgress"
                  label="Confirm"
                  i18n-label="Sign Up Confirm|Confirm button label@@sign-up-confirm-button-label"
                  class="cta-btn center"
                  width="205px"
                  [disabled]="shouldDisableSubmit()"
                  (clicked)="confirmCode()"></app-button>
      <span *ngIf="inProgress" class="progress-spinner">
        <mat-spinner color="primary" class="center" [diameter]="40"></mat-spinner>
      </span>

      <div i18n="Sign Up Confirm|Confirmation code hint@@usign-up-confirm-confirmation-code-hint"
           class="center-align mat-small color-green info-block">
        A confirmation code required to proceed was sent to your email address and should arrive soon. It might get to some inbox folder (depending on your provider and inbox rules), so please check folders like Updates, Promotions, Spam or similar.
      </div>

      <div class="footer center-align mat-body">
        <ng-container i18n="Sign Up Confirm|No code prompt@@sign-up-confirm-no-code-prompt">Didn't receive a code?</ng-container>
        <app-link label="Send again"
                  class="send-again-link"
                  i18n-label="Sign Up Confirm|Re-send code link label@@sign-up-confirm-re-send-code-link-label"
                  (click)="sendAgain()"></app-link>
      </div>
    </form>

    <div class="language-switch">
      <language-switch theme="dark"></language-switch>
    </div>
  </div>
</main-content-holder>
